import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { loginApi, validateApi } from "../services/api";

// LOGIN
export const login = createAsyncThunk(
  "auth/login",
  async ({ email, password }, { rejectWithValue }) => {
    try {
      const res = await loginApi(email, password);

      if (!res.data.status) {
        return rejectWithValue(res.data);
      }

      return res.data.data; // ✅ ONLY TOKEN
    } catch (err) {
      return rejectWithValue(err.response?.data);
    }
  }
);
// VALIDATE
export const validate = createAsyncThunk(
  "auth/validate",
  async (_, { getState }) => {
    const { user } = getState().auth;

    // 🚫 already have user → skip API
    if (user) return user;

    const res = await validateApi();
    return res.data.data;
  }
);


const authSlice = createSlice({
  name: "auth",
  initialState: {
    token: localStorage.getItem("token") || null,
    user: null,
  },
  reducers: {
  logout: (state) => {
    state.token = null;
    state.user = null;
    localStorage.removeItem("token");
  },
  },
  extraReducers: (builder) => {
    builder
.addCase(login.fulfilled, (state, action) => {
  state.token = action.payload; // ✅ JWT string
  localStorage.setItem("token", action.payload); // 🔥 REQUIRED
})
      .addCase(login.rejected, (state, action) => {
        console.log("LOGIN FAILED:", action.payload);
      })
      .addCase(validate.fulfilled, (state, action) => {
        state.user = action.payload;
      });
  },
});

export const { logout } = authSlice.actions;
export default authSlice.reducer;